// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.gUVaOH5Za1tmzaxNOHPW {
  cursor: pointer;
}
.gUVaOH5Za1tmzaxNOHPW svg {
  width: 100%;
  height: 100%;
}
.ml6ibW7VKnk_KlF29ViF,
.al8N1LVTjII_PtZucx0V {
  cursor: pointer;
  width: 8px;
  height: 8px;
  position: absolute;
  border: 2px solid #31d0c6;
  z-index: 1;
  border-radius: 50%;
}
.EFyRew3eHRghUqEr6601 {
  position: relative;
}
`, "",{"version":3,"sources":["webpack://./src/admin-pages/Equipments/Item/GraphDesign/styles/nozzle.module.less"],"names":[],"mappings":"AAAA;EACE,eAAA;AACF;AAFA;EAII,WAAA;EACA,YAAA;AACJ;AAGA;;EACE,eAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EAEA,yBAAA;EACA,UAAA;EACA,kBAAA;AADF;AAIA;EACE,kBAAA;AAFF","sourcesContent":[".nozzleImage {\n  cursor: pointer;\n\n  svg {\n    width: 100%;\n    height: 100%;\n  }\n}\n\n.instNozzle, .defaultNozzle {\n  cursor: pointer;\n  width: 8px;\n  height: 8px;\n  position: absolute;\n  border-radius: 50%;\n  border: 2px solid #31d0c6;\n  z-index: 1;\n  border-radius: 50%;\n}\n\n.image {\n  position: relative;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"nozzleImage": `gUVaOH5Za1tmzaxNOHPW`,
	"instNozzle": `ml6ibW7VKnk_KlF29ViF`,
	"defaultNozzle": `al8N1LVTjII_PtZucx0V`,
	"image": `EFyRew3eHRghUqEr6601`
};
export default ___CSS_LOADER_EXPORT___;
